import { IGetMenuResponse, IGetMenuTransform, ITransformLabels } from './../model/types'

export const transformMenuUser = (data: IGetMenuResponse): IGetMenuTransform => {
  if (!!data.result.categories && data.result.categories.length) {
    data.result.categories.forEach((category) => {
      category.products.forEach((product) => {
        if (product.labels !== null) {
          const updatedLabels: ITransformLabels = {
            vegan: {
              name: 'Веган',
              status: false,
              icon: 'IconProductVegan'
            },
            spicy: {
              name: 'Острое',
              status: false,
              icon: 'IconProductSpicy'
            },
            gluten_free: {
              name: 'Безглютеновое',
              status: false,
              icon: 'IconProductGluten'
            },
            dietary: {
              name: 'Диетическое',
              status: false,
              icon: 'IconProductDietary'
            },
            hit: {
              name: 'Хит',
              status: false,
              icon: 'IconProductHit'
            },
            child: {
              name: 'Детское меню',
              status: false,
              icon: 'IconProductChild'
            },
            new: {
              name: 'Новое',
              status: false,
              icon: 'IconProductNew'
            },
            seasonal: {
              name: 'Сезонное',
              status: false,
              icon: 'IconProductSeasonal'
            }
          }
          for (const labelName of Object.keys(product.labels) as (keyof ITransformLabels)[]) {
            updatedLabels[labelName] = {
              ...updatedLabels[labelName],
              status: product.labels[labelName] as boolean
            }
          }
          product.labels = updatedLabels
        }
      })
    })
  }
  return {
    success: data.success,
    categories: data.result.categories,
    status: data.result.status,
    visible: data.result.visible
  }
}
